export default () => ({
  show: false,
  query: "",
  focus() {
    this.$refs.searchInput.focus();
  },
  blur() {
    this.$refs.searchInput.blur();
  },
  close() {
    this.show = false;
    Grebify.noScroll(false);
    this.blur();
    // Scroll to top when search is closed
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  open() {
    this.show = true;
    this.query = "";

    // Immediately clear the input value
    if (this.$refs.searchInput) {
      this.$refs.searchInput.value = "";
    }

    Grebify.noScroll(true);

    setTimeout(() => {
      // Clear again after transition to be absolutely sure
      if (this.$refs.searchInput) {
        this.$refs.searchInput.value = "";
      }
      this.focus();
    }, 400);
  },
  toggle() {
    var show = !this.show;
    Grebify.noScroll(!show);
    if (show) {
      // Clear query and input value before opening
      this.query = "";
      if (this.$refs.searchInput) {
        this.$refs.searchInput.value = "";
      }
      this.open();
    } else {
      this.close();
    }
  },
  reset() {
    // Clear the search query and input value
    this.query = "";
    if (this.$refs.searchInput) {
      this.$refs.searchInput.value = "";
    }
  },
});
